import script from "./MailSecurity.vue?vue&type=script&setup=true&lang=js"
export * from "./MailSecurity.vue?vue&type=script&setup=true&lang=js"

import "./MailSecurity.vue?vue&type=style&index=0&id=e2f49266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f49266"]])

export default __exports__